import AxiosRequest from './AxiosRequest';

export default class SchoolContract {
    search(data) {
        return new AxiosRequest().get(`schoolContract/search`, data)
    }
    getSchoolIdFromContract(data){
        return new AxiosRequest().get(`schoolContract/getSchoolIdFromContract`, data)
    }
}
